function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useMutation, useQuery } from "@apollo/client";
import { Field, Form as FormikForm, Formik, FieldArray } from "formik";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import React from "react";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "../ProjectDetails/ProjectDetails.css";
import { TASK_DETAILS_QUERY, EDIT_TASK_DETAILS_MUTATION, DELETE_TASK_MUTATION } from "./query.js";
import { toast } from "react-toastify";
import { PROJECT_TASKS_QUERY } from "./../ProjectDetails/query.js";
import { TASK_USERS_QUERY } from "./../ManualPages/query.js";
import SearchBar from "../SearchBar";
import { FilterContext } from "../index";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { GoCalendar } from "react-icons/go";
import { arrayToStringOutput } from "./../SideMenu/Header";
import Loader from "./../Loader/Loader";
import { isRateLimited, rateLimitMessage } from "../utils";
var taskStatusList = [{
  value: "active",
  label: "Active"
}, {
  value: "completed",
  label: "Completed"
}];
var taskPriorityList = [{
  value: "low",
  label: "Low"
}, {
  value: "medium",
  label: "Medium"
}, {
  value: "high",
  label: "High"
}];
export var TaskModal = function TaskModal(props) {
  var _taskData$dueDate, _taskData$taskName, _taskData$taskStatus;
  var taskData = props.taskData,
    taskSummary = props.taskSummary,
    taskDetails = props.taskDetails,
    handleClose = props.handleClose,
    projectId = props.projectId,
    taskId = props.taskId,
    organisationId = props.organisationId,
    existUserIds = props.existUserIds,
    userId = props.userId,
    startDate = props.startDate,
    endDate = props.endDate,
    timezone = props.timezone,
    taskUser = props.taskUser,
    role = props.role,
    user = props.user;
  if (!taskDetails) return null;
  var _useQuery = useQuery(TASK_USERS_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId
      },
      skip: !organisationId
    }),
    usersData = _useQuery.data,
    usersError = _useQuery.error,
    usersLoading = _useQuery.loading,
    usersRefetch = _useQuery.refetch;
  var userDetails = !usersLoading && !usersError ? usersData === null || usersData === void 0 ? void 0 : usersData.getTaskUserDetails : null;
  var selectedUserIds = [];
  if (taskUser !== null && taskUser !== void 0 && taskUser.length) {
    selectedUserIds = taskUser.map(function (team) {
      return team.userId;
    });
  }
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
    return user.userId;
  });
  var _React$useContext = React.useContext(FilterContext),
    organisationSettings = _React$useContext.organisationSettings;
  var _React$useState = React.useState(selectedUserIds),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    userActive = _React$useState2[0],
    setUserActive = _React$useState2[1];
  var _React$useState3 = React.useState(""),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    searchUser = _React$useState4[0],
    setSearchUser = _React$useState4[1];
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isUserSelected = _React$useState6[0],
    setUserSelected = _React$useState6[1];
  var _React$useState7 = React.useState((_taskData$dueDate = taskData.dueDate) !== null && _taskData$dueDate !== void 0 ? _taskData$dueDate : null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    manualStartDate = _React$useState8[0],
    setManualStartDate = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isManualDatePickerOpen = _React$useState10[0],
    setIsManualDatePickerOpen = _React$useState10[1];
  var _React$useState11 = React.useState(""),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    employeeSearch = _React$useState12[0],
    setEmployeeSearch = _React$useState12[1];
  var _useMutation = useMutation(EDIT_TASK_DETAILS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    editTaskDetails = _useMutation2[0],
    editTaskDetailsLoading = _useMutation2[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, actions) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!editTaskDetailsLoading) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            _context.next = 5;
            return editTaskDetails({
              variables: {
                taskName: values.taskName,
                projectId: projectId,
                organisationId: organisationId,
                taskId: taskId,
                status: values.status,
                taskTime: values.taskTime === null ? null : Number(values.taskTime) * 60 * 60,
                userId: userActive,
                dueDate: moment(manualStartDate),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
              },
              // update: updateNewTaskCache(projectId, organisationId, taskId, startDate, endDate, timezone),

              refetchQueries: [{
                query: TASK_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId,
                  taskId: taskId,
                  projectId: projectId,
                  startDate: startDate,
                  endDate: endDate,
                  timeZone: timezone,
                  limit: 10,
                  offset: 0,
                  role: role,
                  userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }],
              awaitRefetchQueries: true
            });
          case 5:
            response = _context.sent;
            if (!(!response || !response.data)) {
              _context.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            handleClose();
            toast.success("Task updated successfully!");
          case 12:
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);
            if (isRateLimited(_context.t0)) {
              toast.error(rateLimitMessage(_context.t0));
            }
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 14]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [editTaskDetails, editTaskDetailsLoading, userActive, manualStartDate]);
  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp, _filterUsersData$disp2, _filterUsersData$disp3, _filterUsersData$disp4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp = filterUsersData.displayName) === null || _filterUsersData$disp === void 0 ? void 0 : (_filterUsersData$disp2 = _filterUsersData$disp.toLowerCase) === null || _filterUsersData$disp2 === void 0 ? void 0 : (_filterUsersData$disp3 = _filterUsersData$disp2.call(_filterUsersData$disp)) === null || _filterUsersData$disp3 === void 0 ? void 0 : (_filterUsersData$disp4 = _filterUsersData$disp3.includes) === null || _filterUsersData$disp4 === void 0 ? void 0 : _filterUsersData$disp4.call(_filterUsersData$disp3, searchUser.toLowerCase());
    });
  };
  var handleChange = function handleChange(e) {
    setIsManualDatePickerOpen(!isManualDatePickerOpen);
    setManualStartDate(e);
  };
  var time = Math.round(Number(taskData === null || taskData === void 0 ? void 0 : taskData.estimatedTime) / 3600);
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    className: "project-task-edit-modals-root"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      taskName: (_taskData$taskName = taskData.taskName) !== null && _taskData$taskName !== void 0 ? _taskData$taskName : "",
      // status: "active",
      status: (_taskData$taskStatus = taskData.taskStatus) !== null && _taskData$taskStatus !== void 0 ? _taskData$taskStatus : "active",
      // users: existUserIds ? existUserIds : [],
      projectId: projectId,
      organisationId: organisationId,
      taskTime: Number(time) == 0 ? "" : time
    }
    // validationSchema={MembersSchema}
    ,
    onSubmit: handleSubmit
  }, function (_ref2) {
    var _userWithSearch, _userWithSearch2;
    var setFieldValue = _ref2.setFieldValue,
      values = _ref2.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Modal.Header, {
      closeButton: true
    }, /*#__PURE__*/React.createElement(Modal.Title, {
      className: "project-task-edit-modals-root-title"
    }, "Edit Task Details")), /*#__PURE__*/React.createElement(Modal.Body, {
      className: "project-details-task-card-edit-task-body"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "taskName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "project-details-edit-task-label-name"
      }, "Task Name ", /*#__PURE__*/React.createElement("sup", {
        className: "project-task-modals-edit-task-label-name-star"
      }, "*")), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        type: "text",
        placeholder: "e.g. Research and Analysis",
        className: "project-details-edit-task-label-input"
      }, field)));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "status"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "project-details-edit-task-label-name"
      }, "Task Status"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        placeholder: "Select a status",
        className: "project-details-edit-task-label-input"
      }, field), taskStatusList.map(function (taskStatus) {
        return /*#__PURE__*/React.createElement("option", {
          key: taskStatus.value,
          value: taskStatus.value
        }, taskStatus.label);
      })));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "task-date-whole-div-data"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "taskTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "manage-teams-edit-task-label-name"
      }, "Estimated Time (Optional)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "my-tasks-add-new-project-option-div"
      }, /*#__PURE__*/React.createElement(Form.Control, _extends({
        type: "number",
        min: "0",
        placeholder: "e.g. 10",
        className: "task-add-placeholder"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "task-add-new-project-hours-text"
      }, "Hours")));
    }), /*#__PURE__*/React.createElement("div", {
      className: "task-due-date"
    }, /*#__PURE__*/React.createElement(Form.Label, {
      className: "manage-teams-edit-task-label-name"
    }, "Due Date (Optional)"), !isUserSelected ? /*#__PURE__*/React.createElement(Form.Label, {
      className: "error"
    }, "Required") : null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      trigger: "click",
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Popover, {
        className: "page-content-wrapper-menu-filter-overlay-trigger"
      }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(DatePicker, {
        selected: manualStartDate,
        onChange: handleChange,
        open: isManualDatePickerOpen,
        inline: true
      })))
    }, /*#__PURE__*/React.createElement("div", {
      className: "workfolio-manual-pages-calender-div manual-page-content-wrapper-filter-date-date-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "workfolio-manual-pages-calender-icon-div "
    }, /*#__PURE__*/React.createElement(GoCalendar, {
      className: "workfolio-manual-section-calender-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "workfolio-manual-section-calender-text"
    }, manualStartDate ? arrayToStringOutput([manualStartDate, manualStartDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) : /*#__PURE__*/React.createElement("span", {
      className: "task-add-due-date-span"
    }, "No due date selected")))))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-edit-modal-content-person-name-header-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-header-section-label"
    }, "Assign Task To"), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-header-section-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-searchbox-wrapper"
    }, /*#__PURE__*/React.createElement(SearchBar, {
      value: searchUser,
      onChange: setSearchUser,
      placeholder: "Search employee name"
    })), (userActive === null || userActive === void 0 ? void 0 : userActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
      className: "projects-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setUserActive([]);
        setUserSelected(true);
      }
    }, "Unselect All Employees") : /*#__PURE__*/React.createElement("p", {
      //variant="outline-secondary"
      className: "projects-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setUserActive(userIds);
        setUserSelected(true);
      }
    }, "Select All Employees")))), /*#__PURE__*/React.createElement("div", {
      className: "project-details-tasks-modal-content-person-name-listing"
    }, usersLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch = userWithSearch(userDetails)) !== null && _userWithSearch !== void 0 && _userWithSearch.length ? (_userWithSearch2 = userWithSearch(userDetails)) === null || _userWithSearch2 === void 0 ? void 0 : _userWithSearch2.map(function (user, index) {
      var teamFirstName = user.displayName.match(/\b(\w)/g);
      var teamNameIcon = teamFirstName.join("");
      return /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-person-name-listing-card-content",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "tasks-modal-content-person-name-listing-card-content-person",
        onClick: function onClick() {
          setUserSelected(true);
          setUserActive(function (prev) {
            return prev.includes(user.userId) ? prev.filter(function (a) {
              return a !== user.userId;
            }) : [].concat(_toConsumableArray(prev), [user.userId]);
          });
        }
      }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "task-card-avatar-profile"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: user === null || user === void 0 ? void 0 : user.profileUrl,
        className: "task-card-avatar-profile-img"
      }))) : /*#__PURE__*/React.createElement("div", {
        className: "tasks-modal-content-person-name-listing-card-content-person-icon"
      }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-header-team-name"
      }, user.displayName)), /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-team-name"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: user.userId,
        name: "myRadioGroup",
        className: "create-project-team-selection-control-checkbox",
        checked: userActive.includes(user.userId),
        onChange: function onChange() {
          setUserSelected(true);
          setUserActive(function (prev) {
            return prev.includes(user.userId) ? prev.filter(function (a) {
              return a !== user.userId;
            }) : [].concat(_toConsumableArray(prev), [user.userId]);
          });
        }
      })));
    }) :
    /*#__PURE__*/
    // {!userWithSearch(userDetails).length ? (
    React.createElement("div", {
      className: "text-muted text-center"
    }, "No member found for \"".concat(searchUser, "\"\n                              "))
    // ) : null
    ))))), /*#__PURE__*/React.createElement(Modal.Footer, {
      className: "project-details-task-card-save-button-div"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "project-details-task-card-save-button",
      type: "submit"
    }, editTaskDetailsLoading ? "Loading" : "Save Changes")));
  }));
};
export var DeleteTaskModal = function DeleteTaskModal(props) {
  var showTaskDeleteModal = props.showTaskDeleteModal,
    handleTaskDeleteClose = props.handleTaskDeleteClose,
    taskId = props.taskId,
    organisationId = props.organisationId,
    projectId = props.projectId,
    userId = props.userId,
    history = props.history,
    teamId = props.teamId,
    startDate = props.startDate,
    endDate = props.endDate,
    TASK_LIMIT = props.TASK_LIMIT,
    timezone = props.timezone,
    role = props.role,
    user = props.user;
  if (showTaskDeleteModal === false) {
    return null;
  }
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    deleteStatus = _React$useState14[0],
    setDeleteStatus = _React$useState14[1];
  var _useMutation3 = useMutation(DELETE_TASK_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    deleteTask = _useMutation4[0],
    deleteTaskLoading = _useMutation4[1].loading;
  var handleDeleteProject = React.useCallback(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!deleteTaskLoading) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.next = 4;
            return deleteTask({
              variables: {
                taskId: taskId,
                organisationId: organisationId,
                projectId: projectId,
                userId: userId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PROJECT_TASKS_QUERY,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  teamId: teamId,
                  startDate: moment(startDate).format("YYYY-MM-DD"),
                  endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                  taskStatus: "active",
                  search: null,
                  limit: TASK_LIMIT,
                  offset: 0,
                  timezone: timezone,
                  role: role,
                  url: user === null || user === void 0 ? void 0 : user.uniqueUrl
                }
              }]
            });
          case 4:
            response = _context2.sent;
            if (!response || !response.data || !response.data.deleteTask) {
              toast.success("Error, Try again");
            } else {
              handleTaskDeleteClose();
              toast.success("Task deleted successfully!");
              setDeleteStatus(true);
              history.goBack();
            }
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  }, [deleteTask, deleteTaskLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showTaskDeleteModal,
    onHide: handleTaskDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Task")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Are you sure you want this delete task?"), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleTaskDeleteClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleDeleteProject()
  }, deleteTaskLoading ? "Loading" : deleteStatus === true ? "Deleted" : "Delete Task")));
};